import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4a1f79f0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4a1f79f0&prod&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=4a1f79f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1f79f0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Empty: require('/drone/src/components/Empty/index.vue').default,TimeCountdown: require('/drone/src/components/TimeCountdown/index.vue').default,SellerDetailsFastSell: require('/drone/src/components/SellerDetails/fastSell.vue').default,ConjoinedGoodsConfigPop: require('/drone/src/components/ConjoinedGoods/configPop.vue').default,PzImage: require('/drone/src/components/PzImage/index.vue').default,WxFollowQr: require('/drone/src/components/WxFollowQr.vue').default})
